import { render, staticRenderFns } from "./_Layout.vue?vue&type=template&id=07c34df3&scoped=true&"
import script from "./_Layout.vue?vue&type=script&lang=ts&"
export * from "./_Layout.vue?vue&type=script&lang=ts&"
import style0 from "./_Layout.vue?vue&type=style&index=0&id=07c34df3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c34df3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VMain,VSheet})
